import { useState, FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [statusMsg, setStatusMsg] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value || '';
    if (honeypot.trim()) {
      setStatus('success');
      setStatusMsg('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    setStatus('loading');
    try {
      const formData = new FormData(form);
      const res = await fetch('https://readdy.ai/api/form/d9pegqli2vhsdh2d32lg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setStatusMsg('订阅成功！感谢您的关注，最新漫画更新将第一时间通知您。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试。';
        setStatus('error');
        setStatusMsg(serverMsg);
      }
    } catch {
      setStatus('error');
      setStatusMsg('网络错误，请检查网络后重试。');
    }
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-primary-500">
      <div className="w-full max-w-2xl mx-auto text-center">
        <i className="ri-mail-send-line text-4xl text-background-50/80 w-10 h-10 flex items-center justify-center mx-auto mb-4"></i>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
          订阅漫画更新
        </h2>
        <p className="text-sm text-background-50/80 mb-8 leading-relaxed">
          第一时间获取最新漫画上架通知和独家优惠活动，精彩内容不再错过。
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 px-5 py-3 text-sm rounded-full bg-background-50 text-foreground-800 placeholder:text-foreground-400 outline-none focus:ring-2 focus:ring-accent-400"
          />
          <div className="anti-spam-wrapper">
            <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
          </div>
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-6 py-3 text-sm font-medium rounded-full bg-accent-500 text-background-50 hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer disabled:opacity-60"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>

        {status !== 'idle' && status !== 'loading' && (
          <p
            className={`mt-4 text-sm ${
              status === 'success' ? 'text-background-50' : 'text-accent-200'
            }`}
          >
            {statusMsg}
          </p>
        )}
      </div>
    </section>
  );
}